import localeRu from 'air-datepicker/locale/ru';

function delegate(eventName, elementSelector, handler, listener = document) {
    if (!listener)
        return false;

    listener.addEventListener(eventName, function (e) {
        for (var target = e.target; target && target != this; target = target.parentNode) {
            if (target.matches(elementSelector)) {
                handler.call(target, e, target);
                break;
            }
        }
    });
}

export function getMontNameByNumber(monthNumber, type = 0) {
    let months = [
        ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря']
    ]
    return months[type][monthNumber]
}

export default class CustomCalendar {
    constructor({ onDateSelect, containerSelector, addToNextMonth = true, onToggleMonth = null, afterInit = null }) {
        this.AirDatepicker
        import(/* webpackChunkName: "air-datepciker" */ 'air-datepicker').then(module => {
            this.AirDatepicker = module.default
            return true
        }).then(() => {
            this._initCalendar({ onDateSelect, containerSelector, addToNextMonth, onToggleMonth })
        }).then(() => {
            if (afterInit)
                afterInit()
        })

        this.todayDate = new Date()
        this.todayWeekdayNum = this.todayDate.getDay()
        this.todayMonth = this.todayDate.getMonth()
        this.todayMonthDay = this.todayDate.getDate()
        this.todayYear = this.todayDate.getFullYear()
        this.pickedDate = null
        this.isShowingNextMonth = false
        this.isDateSelected = false
    }
    _initCalendar({ onDateSelect, containerSelector, addToNextMonth, onToggleMonth }) {
        this.datepickerContainer = document.querySelector(containerSelector)

        let maxMonth = this.todayMonth + 1
        maxMonth = maxMonth > 12 ? 1 : maxMonth
        this.datepicker = new this.AirDatepicker(this.datepickerContainer, {
            locale: localeRu,
            onSelect: ({ date, formattedDate, datepicker }) => {
                this.pickedDate = date

                onDateSelect({ date })
            },
            onRenderCell: ({ date, cellType }) => {
                if (cellType === 'day') {
                    if ((date.getDate() < this.todayMonthDay && date.getMonth() <= this.todayMonth) || (date.getMonth() < this.todayMonth))
                        return {
                            disabled: true
                        }
                }
            },
            minView: 'days',
            showOtherMonths: true,
            minDate: new Date(this.todayYear, this.todayMonth, 1),
            maxDate: new Date(this.todayYear, maxMonth, 31)
        })

        if (addToNextMonth)
            delegate('click', '[data-nav-toggle-month]', (event, btn) => {
                this._onToggleMonth(event, btn)
                if (onToggleMonth)
                    onToggleMonth()
            }, this.datepickerContainer)

        let todayMonthName = getMontNameByNumber(this.todayMonth)
        let nextMonth = this.todayMonth + 1
        if (nextMonth > 11)
            nextMonth = 1
        let nextMonthName = getMontNameByNumber(nextMonth)

        let add = addToNextMonth ? addToNextMonth : ''
        let navigationTpl = `
                    <div class="section-church-calendar__calendar-navigation">
                        <div class="section-church-calendar__calendar-current-month" data-current-month><h4>${todayMonthName}</h4></div>
                        ${add && `<div class="section-church-calendar__calendar-toggle-month" data-nav-toggle-month><h4>${nextMonthName}</h4>
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.24952 12L0 10.4012L4.95238 6L0 1.59878L1.24952 -2.95073e-07L8 6L1.24952 12Z" fill="#1B1B1C"/>
                            </svg>
                        </div>`}
                    </div>
                `
        this.datepickerContainer.insertAdjacentHTML('afterbegin', navigationTpl)
        this.currentMonthContainer = this.datepickerContainer.querySelector('[data-current-month]')

        return true
    }
    _onToggleMonth(event, btn) {
        if (this.isShowingNextMonth)
            this.datepicker.prev()
        else
            this.datepicker.next()

        this.isShowingNextMonth = !this.isShowingNextMonth
        let viewDate = this.datepicker.viewDate
        let viewMonth = viewDate.getMonth()
        let altMonth = this.isShowingNextMonth ? viewMonth - 1 : viewMonth + 1
        if (altMonth < 1)
            altMonth = 11
        else if (altMonth > 11)
            altMonth = 1

        const btnRight =
            `
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.24952 12L0 10.4012L4.95238 6L0 1.59878L1.24952 -2.95073e-07L8 6L1.24952 12Z" fill="#1B1B1C"/>
        </svg>
        `

        const btnLeft =
            `
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.75048 2.95073e-07L8 1.59878L3.04762 6L8 10.4012L6.75048 12L0 6L6.75048 2.95073e-07Z" fill="#1B1B1C"/>
        </svg>
        `

        let altMonthName = getMontNameByNumber(altMonth)
        let btnContent = this.isShowingNextMonth ? `${btnLeft} <h4>${altMonthName}</h4>` : `<h4>${altMonthName}</h4> ${btnRight}`
        btn.innerHTML = `${btnContent}`

        let viewMonthName = getMontNameByNumber(viewMonth)
        this.currentMonthContainer.innerHTML = `<h4>${viewMonthName}</h4>`
    }
    unselectDate() {
        this.datepicker.unselectDate(this.pickedDate)
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const btns = document.querySelectorAll(".btn-datepicker");

    btns.forEach((btn) => {
         const container = btn.closest(".section-church-calendar__datepicker")
         const datepicker = container.querySelector("#datepicker");
        //  console.log(datepicker);
        btn.addEventListener("click", () => {
            datepicker.classList.toggle("active");
        })
    })

})